import { render, staticRenderFns } from "./TankDetailTable.vue?vue&type=template&id=37835172&scoped=true"
import script from "./TankDetailTable.vue?vue&type=script&lang=js"
export * from "./TankDetailTable.vue?vue&type=script&lang=js"
import style0 from "./TankDetailTable.vue?vue&type=style&index=0&id=37835172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37835172",
  null
  
)

export default component.exports